import type { OfficialAssetServerCategory } from '$/api/server.types';
import type { RoleGenMaterialCategory } from './roleFormTypes';

const MATERIAL_CATEGORY_CODES: Record<RoleGenMaterialCategory, string> = {
  clothing: 'roboneo_clothing_genre',
  hairstyle: 'roboneo_hairstyle_genre',
  accessory: 'roboneo_accessory_genre',
};

/** 按服务端稳定 code 选择创建角色当前素材类型对应的官方分类。 */
export function resolveDefaultSubject(
  subjects: OfficialAssetServerCategory[],
  category: RoleGenMaterialCategory,
): OfficialAssetServerCategory | null {
  const categoryCode = MATERIAL_CATEGORY_CODES[category];
  return subjects.find((subject) => subject.code === categoryCode) ?? null;
}
